import moment from 'moment-timezone'
import { getNextStatus } from 'utils/shipmentHelpers'
import TIME_CONSTANTS from 'constants/datetime'
import {
  DIALOG_UPDATE_STATUSES,
  LEAVING_LABELS,
  PICKUP_LABELS,
  KEYED_SHIPMENT_STATUSES,
} from 'constants/shipments'

export const showOsd = nextStatus => LEAVING_LABELS.includes(nextStatus)

export const showInvalidCallback = state => {
  if (!state.callbackDate && state.callbackTime) return true
  // callback time is always in defaultTimeZone (NYC)
  const now = moment()
  const nowInNyc = moment
    .tz(now, TIME_CONSTANTS.defaultTimeZone)
    .format(TIME_CONSTANTS.datetimeFormatApi)
  const callBack = moment
    .tz(
      `${state.callbackDate} ${state.callbackTime}`,
      TIME_CONSTANTS.datetimeInputFormat,
      TIME_CONSTANTS.defaultTimeZone
    )
    .format(TIME_CONSTANTS.datetimeFormatApi)
  const invalidCallback = moment(callBack).isBefore(nowInNyc)
  return invalidCallback
}

const updatedStops = (stops, currentStop) =>
  stops.map(stop => (stop.id === currentStop.id ? { ...stop, ...currentStop } : stop))

export const updateShipmentDetails = (props, state) => {
  const {
    shipment: { carrierAssignmentsAttributes, status, stops },
  } = props
  let { currentStopIndex } = status
  let { currentStop } = state
  const { manualEta, recommendBounceReason } = state
  let nextStatus = ''
  let body = {}
  let updatedManualEtaIfSame

  /* If our inputted manualETA is the same as the stops current manualETA, the task doesn't update
   we go back one second bc going forward 1 second required a late reason  */
  if (moment(manualEta).isSame(currentStop.manualEta)) {
    updatedManualEtaIfSame = moment(manualEta).subtract(1, 's').format()
  }
  if (!state.trackingUpdate) {
    nextStatus = getNextStatus(DIALOG_UPDATE_STATUSES, status.state)
    const { checkinDate, checkinTime } = state
    const cleanCheckinTime = checkinTime.replace(':', '')

    if (PICKUP_LABELS.includes(nextStatus)) {
      currentStop.status.arrivedAtDate = checkinDate
      currentStop.status.arrivedAtTime = `${cleanCheckinTime.slice(0, 2)}:${cleanCheckinTime.slice(
        2
      )}`
      body = { stops: updatedStops(stops, currentStop) }
    }
    if (LEAVING_LABELS.includes(nextStatus)) {
      currentStop.status.leftAtDate = checkinDate
      currentStop.status.leftAtTime = `${cleanCheckinTime.slice(0, 2)}:${cleanCheckinTime.slice(2)}`
      body = { stops: updatedStops(stops, currentStop) }
    }
  }
  if (state.etaDate) {
    /* if we are In Transit, we need to update currentStop to be +1
    in order that the ETA checked will be the delivery ETA */
    if (nextStatus === KEYED_SHIPMENT_STATUSES.in_transit.label) currentStopIndex += 1
    currentStop = stops[currentStopIndex]
    currentStop.lateReason = state.lateReason
    currentStop.manualEta = updatedManualEtaIfSame || state.manualEta
    body = { stops: updatedStops(stops, currentStop) }
  }
  if (state.osd) {
    body = { ...body, info: { has_osd: true } }
  }
  if (recommendBounceReason) {
    const currentCarrier = carrierAssignmentsAttributes.find(carrier => !carrier.bounceReason)
    if (currentCarrier) currentCarrier.recommendedBounceReason = recommendBounceReason
    body = { ...body, carrierAssignmentsAttributes }
  }
  return body
}
